/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getNotes = /* GraphQL */ `
  query GetNotes($customer_id: String!) {
    getNotes(customer_id: $customer_id) {
      account_id
      created_at
      customer_id
      id
      note
      updated_at
    }
  }
`;
